import es from './localeEs';
import pt from './localePt';

export const localeEs = es;
export const localePt = pt;

const locales = { es, pt };

export default locales;
